import {getProductSpecialCategory} from 'modules/product-card/helpers';
import {IProduct} from 'modules/product-card/models/ProductResponse';
import {IPropertyValue} from 'modules/products/types';
import {TIconName} from 'components/Icon/iconNames';

interface IResultProperties {
    icon: TIconName;
    title: string;
}

type TCultivationTypeSlug = 'organika' | 'sustainable' | 'biodinamika';

type TPropertyValidation = (value: any) => boolean;

interface IPropertyConfig {
    code: string;
    icon: TIconName;
    title: string;
    validation: TPropertyValidation;
    excludeCategories?: string[];
}

interface ICultivationTypeConfig {
    code: string;
    iconMap: Record<TCultivationTypeSlug, TIconName>;
    validation: (value: any) => boolean;
}

// const {AKSESSUARY, MINERALNAYA_VODA, STEKLO, VODA_I_SOKI} = SECTION_CODE;

// const NON_ALCOHOLIC_CATEGORIES = [MINERALNAYA_VODA, VODA_I_SOKI, STEKLO, AKSESSUARY];

// Property configurations with validation logic
const PROPERTY_CONFIGS: IPropertyConfig[] = [
    {
        code: 'kosher',
        icon: `kosher`,
        title: 'Кошерное',
        validation: (value) => 1 === value,
    },
    {
        code: 'natural',
        icon: 'natural',
        title: 'Натуральное',
        validation: (value) => '' !== value,
    },
    // {
    //     code: 'alcohol',
    //     icon: 'non-alcoholic',
    //     title: '',
    //     validator: (value) => 0 === value,
    //     excludeCategories: NON_ALCOHOLIC_CATEGORIES,
    // },
    {
        code: 'orange',
        icon: 'orange',
        title: 'Оранжевое',
        validation: (value) => 1 === value,
    },
    {
        code: 'vegan',
        icon: 'vegan',
        title: 'Веганское',
        validation: (value) => 1 === value,
    },
];

const CULTIVATION_TYPE_CONFIG: ICultivationTypeConfig = {
    code: 'cultivationType',
    iconMap: {
        organika: 'organika',
        biodinamika: 'biodinamika',
        sustainable: 'sustainable',
    },
    validation: (value: IPropertyValue) => null !== value?.id,
};

// Подробнее
// https://conf.awg.ru/pages/viewpage.action?pageId=194846045#UC46%D0%9F%D1%80%D0%BE%D1%81%D0%BC%D0%BE%D1%82%D1%80%D0%BE%D1%81%D0%BD%D0%BE%D0%B2%D0%BD%D0%BE%D0%B9%D0%B8%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%86%D0%B8%D0%B8%D0%BE%D1%82%D0%BE%D0%B2%D0%B0%D1%80%D0%B5-FR-1
export const getProductFeatures = (product: IProduct): IResultProperties[] => {
    const features: IResultProperties[] = [];
    const productCategory = getProductSpecialCategory(product);
    const properties = product.properties;

    const getPropertyByCode = (code: string) => {
        return properties.find((prop) => prop.code === code);
    };

    const shouldExcludeCategory = (excludeCategories?: string[]): boolean => {
        return excludeCategories?.includes(productCategory) ?? false;
    };

    const cultivationProperty = getPropertyByCode(CULTIVATION_TYPE_CONFIG.code);
    if (cultivationProperty) {
        const propValue = cultivationProperty.value as IPropertyValue;
        if (CULTIVATION_TYPE_CONFIG.validation(propValue)) {
            features.push({
                icon: CULTIVATION_TYPE_CONFIG.iconMap[propValue.slug as TCultivationTypeSlug],
                title: propValue.value,
            });
        }
    }

    for (const config of PROPERTY_CONFIGS) {
        if (shouldExcludeCategory(config.excludeCategories)) {
            // eslint-disable-next-line no-continue
            continue;
        }

        const property = getPropertyByCode(config.code);

        if (!property) {
            // eslint-disable-next-line no-continue
            continue;
        }

        if (config.validation(property.value)) {
            features.push({
                icon: config.icon,
                title: config.title,
            });
        }
    }

    return features;
};
